// state
const state = () => ({
    cargaTributariaEfetivaSelecionadaST: []
  });
  
  // getters
  const getters = {
    getCargaTributariaEfetivaSelecionadaST: (state) => {
      return state.cargaTributariaEfetivaSelecionadaST;
    }
  };
  
  // mutations
  const mutations = {
    SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA_ST (state, value) {
      state.cargaTributariaEfetivaSelecionadaST = value
    }
  }
  
   // actions
   const actions = {
    /**
     * Deve ser chamado quando clicar no botão Resultado
     * @param {String} cenario
     */
    resetCargasCenarioST ({ commit, state }, { cenario, tributo }) {
      const cargas = state.cargaTributariaEfetivaSelecionadaST.filter(carga => {
        return !(carga.cenario == cenario && carga.tributo == tributo)
      })
  
      commit('SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA_ST', cargas)
    },
    async setCargaTributariaEfetivaST ({ commit, state }, {cenario, tributo, valor}) {
      let found = false
      var atualiza = await state.cargaTributariaEfetivaSelecionadaST.map(carga => {
        if (carga.cenario == cenario && carga.tributo == tributo) {
          carga.valor = valor
          found = true
        }
        return carga
      })
  
      if (!found) {
        atualiza.push({ cenario, tributo, valor })
      }
  
      let total = 0
      let count = 0
      total = await atualiza.reduce(function(acumulador, carga) {
        if (carga.cenario == cenario) {
          if (Number(carga.valor)) {
            count++
            return acumulador + Number(carga.valor)
          }
        }
        return acumulador
      }, 0)
  
      commit('SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA_ST', atualiza)
  
      if (count == 1) return null
  
      return total
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  